import { Component, OnInit, Input} from '@angular/core';
import {Video} from '../../models/video/video';
import {Entry} from 'contentful';
import {LiveEvent} from '../../models/live-event/live-event';

@Component({
  selector: 'app-video-strip',
  templateUrl: './video-strip.component.html',
  styleUrls: ['./video-strip.component.scss']
})

export class VideoStripComponent implements OnInit {
  @Input()
  title;

  @Input()
  videos: Video[] = [];

  constructor() { }

  ngOnInit() {

  }

}
